import { Link } from "react-router-dom";
import {
  UserPlus, Building2, CalendarDays, Route, Bell, MessageSquare,
  FileText, ClipboardList,
} from "lucide-react";
import "./dashboard.scss";

const ALL_ACTIONS = {
  newVigilante: { label: "Nuevo vigilante", to: "/vigilantes/new", Icon: UserPlus },
  newCliente: { label: "Nuevo cliente", to: "/clientes/newCliente", Icon: Building2 },
  cuadrantes: { label: "Cuadrante del mes", to: "/cuadrantes", Icon: CalendarDays },
  rondas: { label: "Control de rondas", to: "/control-rondas", Icon: Route },
  notificaciones: { label: "Notificaciones", to: "/notificaciones-internas", Icon: Bell },
  buzon: { label: "Buzón anónimo", to: "/buzon-anonimo", Icon: MessageSquare },
  documentos: { label: "Documentos", to: "/documentos", Icon: FileText },
  cuadranteVigilante: { label: "Cuadrante por vigilante", to: "/cuadrantes", Icon: ClipboardList },
};

const getShortcutsForRole = (roles = []) => {
  const isInspector = roles.includes("inspector") &&
    !roles.includes("administrador") &&
    !roles.includes("administrativo");

  if (isInspector) {
    return [
      ALL_ACTIONS.cuadrantes,
      ALL_ACTIONS.rondas,
      ALL_ACTIONS.documentos,
      ALL_ACTIONS.cuadranteVigilante,
      ALL_ACTIONS.notificaciones,
      ALL_ACTIONS.buzon,
    ];
  }

  return [
    ALL_ACTIONS.newVigilante,
    ALL_ACTIONS.newCliente,
    ALL_ACTIONS.cuadrantes,
    ALL_ACTIONS.rondas,
    ALL_ACTIONS.notificaciones,
    ALL_ACTIONS.buzon,
  ];
};

const QuickActions = ({ roles }) => {
  const actions = getShortcutsForRole(roles);
  return (
    <div className="quick-actions">
      {actions.map(({ label, to, Icon }) => (
        <Link key={to + label} to={to} className="quick-action">
          <div className="qa-icon"><Icon size={22} /></div>
          <span className="qa-label">{label}</span>
        </Link>
      ))}
    </div>
  );
};

export default QuickActions;
